var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("h2", { staticClass: "pb-4" }, [_vm._v("Settings")]),
      _c("v-divider"),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("v-select", {
                        attrs: {
                          dense: "",
                          label: "Forecast Method",
                          items: _vm.forecastTypeItems,
                          rules: [
                            function (v) {
                              return !!v || "required"
                            },
                          ],
                        },
                        on: {
                          change: function ($event) {
                            return _vm.change()
                          },
                        },
                        model: {
                          value: _vm.computedValue.input.settings.type,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedValue.input.settings,
                              "type",
                              $$v
                            )
                          },
                          expression: "computedValue.input.settings.type",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pr-6" },
                    [
                      _c("InputDateTime", {
                        attrs: {
                          dense: "",
                          label: "Forecast Start Date",
                          dateRules: _vm.forecastStartRules,
                          timeRules: _vm.timeRules,
                          timezone: "UTC",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value:
                            _vm.computedValue.input.settings
                              .start_of_forecast_date,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedValue.input.settings,
                              "start_of_forecast_date",
                              $$v
                            )
                          },
                          expression:
                            "computedValue.input.settings.start_of_forecast_date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("InputDateTime", {
                        attrs: {
                          dense: "",
                          label: "Forecast End Date",
                          timeRules: _vm.timeRules,
                          dateRules: _vm.forecastEndRules,
                          timezone: "UTC",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value:
                            _vm.computedValue.input.settings
                              .end_of_forecast_date,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedValue.input.settings,
                              "end_of_forecast_date",
                              $$v
                            )
                          },
                          expression:
                            "computedValue.input.settings.end_of_forecast_date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          dense: "",
                          label: "Forecast Granularity",
                          items: _vm.forecastGranularityItems,
                          rules: [
                            function (v) {
                              return !!v || "required"
                            },
                          ],
                        },
                        on: {
                          change: function ($event) {
                            return _vm.change()
                          },
                        },
                        model: {
                          value: _vm.computedValue.input.settings.profile,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedValue.input.settings,
                              "profile",
                              $$v
                            )
                          },
                          expression: "computedValue.input.settings.profile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("v-switch", {
                        attrs: { dense: "", label: "High Forecast Value" },
                        on: {
                          change: function ($event) {
                            return _vm.change()
                          },
                        },
                        model: {
                          value: _vm.toggleHFV,
                          callback: function ($$v) {
                            _vm.toggleHFV = $$v
                          },
                          expression: "toggleHFV",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("v-switch", {
                        attrs: { dense: "", label: "Low Forecast Value" },
                        on: {
                          change: function ($event) {
                            return _vm.change()
                          },
                        },
                        model: {
                          value: _vm.toggleLFV,
                          callback: function ($$v) {
                            _vm.toggleLFV = $$v
                          },
                          expression: "toggleLFV",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("v-switch", {
                        attrs: { dense: "", label: "Forecast Limiter" },
                        on: {
                          change: function ($event) {
                            return _vm.change()
                          },
                        },
                        model: {
                          value:
                            _vm.computedValue.input.settings.forecast_limit_lag,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedValue.input.settings,
                              "forecast_limit_lag",
                              $$v
                            )
                          },
                          expression:
                            "computedValue.input.settings.forecast_limit_lag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { sm: "3" } },
                    [
                      _vm.toggleHFV
                        ? _c("v-text-field", {
                            attrs: {
                              dense: "",
                              label: "HFV multiplier",
                              type: "number",
                              rules: _vm.hfvRules,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.change()
                              },
                            },
                            model: {
                              value: _vm.computedValue.input.settings.hfv,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedValue.input.settings,
                                  "hfv",
                                  _vm._n($$v)
                                )
                              },
                              expression: "computedValue.input.settings.hfv",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { sm: "3" } },
                    [
                      _vm.toggleLFV
                        ? _c("v-text-field", {
                            attrs: {
                              dense: "",
                              label: "LFV multiplier",
                              type: "number",
                              rules: _vm.lfvRules,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.change()
                              },
                            },
                            model: {
                              value: _vm.computedValue.input.settings.lfv,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedValue.input.settings,
                                  "lfv",
                                  _vm._n($$v)
                                )
                              },
                              expression: "computedValue.input.settings.lfv",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.value.input.settings.forecast_limit_lag
                    ? _c(
                        "v-col",
                        { attrs: { sm: "6" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      label: "Max Forecast Limit",
                                      type: "number",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.change()
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedValue.input.settings
                                          .max_forecast_limit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedValue.input.settings,
                                          "max_forecast_limit",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "computedValue.input.settings.max_forecast_limit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { sm: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      label: "Min Forecast Limit",
                                      type: "number",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.change()
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedValue.input.settings
                                          .min_forecast_limit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedValue.input.settings,
                                          "min_forecast_limit",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "computedValue.input.settings.min_forecast_limit",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.computedValue.input.settings.type == "IHR"
        ? [
            _c("h2", { staticClass: "pb-4 pt-4" }, [_vm._v("Inputs")]),
            _c("v-divider"),
            _c(
              "v-card",
              { attrs: { flat: "" } },
              [
                _c("v-card-subtitle", [
                  _c("h3", [_vm._v("Energy/Ancillary Price Inputs")]),
                ]),
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-card",
                      { attrs: { outlined: "" } },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-row",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "4" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: "Start Year",
                                        items: _vm.startYearItems,
                                        dense: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "required"
                                          },
                                        ],
                                      },
                                      model: {
                                        value:
                                          _vm.computedValue.input
                                            .energy_ancillary_inputs.year_start,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.computedValue.input
                                              .energy_ancillary_inputs,
                                            "year_start",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "computedValue.input.energy_ancillary_inputs.year_start",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "4" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: "End Year",
                                        items: _vm.endYearItems,
                                        dense: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "required"
                                          },
                                        ],
                                      },
                                      model: {
                                        value:
                                          _vm.computedValue.input
                                            .energy_ancillary_inputs.year_end,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.computedValue.input
                                              .energy_ancillary_inputs,
                                            "year_end",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "computedValue.input.energy_ancillary_inputs.year_end",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "4" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: "Shaping Year",
                                        items: _vm.shapingYearItems,
                                        dense: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "required"
                                          },
                                        ],
                                      },
                                      model: {
                                        value:
                                          _vm.computedValue.input
                                            .energy_ancillary_inputs
                                            .shaping_year,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.computedValue.input
                                              .energy_ancillary_inputs,
                                            "shaping_year",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "computedValue.input.energy_ancillary_inputs.shaping_year",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { sm: "12" } },
                                  [
                                    _c("h4", { staticClass: "pb-4" }, [
                                      _vm._v("Energy Price Inputs"),
                                    ]),
                                    _c("v-divider", { staticClass: "pt-4" }),
                                    _c(
                                      "v-col",
                                      { attrs: { sm: "12" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            dense: "",
                                            label: "Price Source",
                                            items: _vm.priceSourceItems,
                                            "item-text": "text",
                                            rules: [
                                              function (v) {
                                                return !!v || "required"
                                              },
                                            ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.change()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.computedValue.input
                                                .energy_ancillary_inputs
                                                .energy_settings
                                                .energy_price_source,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.computedValue.input
                                                  .energy_ancillary_inputs
                                                  .energy_settings,
                                                "energy_price_source",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "\n                      computedValue.input.energy_ancillary_inputs.energy_settings\n                        .energy_price_source\n                    ",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.energyMarketSelection
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "pt-4",
                                                attrs: { dense: "" },
                                              },
                                              [
                                                _c("InputPriceMarket", {
                                                  attrs: {
                                                    "energy-price-source":
                                                      "market",
                                                    "ancillary-price-source":
                                                      "custom",
                                                    dense: "",
                                                    "node-list": false,
                                                    "date-range": true,
                                                    "auto-select-first-market":
                                                      "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.$emit("change")
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.markets,
                                                    callback: function ($$v) {
                                                      _vm.markets = $$v
                                                    },
                                                    expression: "markets",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.computedValue.input
                                      .energy_ancillary_inputs.energy_settings
                                      .energy_price_source == "custom"
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c("InputYearlyProfile", {
                                              attrs: {
                                                label: "Custom Profile",
                                                num_years: _vm.numYears,
                                                "spread-values": "",
                                                fill: "",
                                                "object-value": "",
                                                "items-type": "profile",
                                                "profile-type": "ENERGY_PRICE",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.computedValue.input
                                                    .energy_ancillary_inputs
                                                    .energy_settings.profile,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.computedValue.input
                                                      .energy_ancillary_inputs
                                                      .energy_settings,
                                                    "profile",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "computedValue.input.energy_ancillary_inputs.energy_settings.profile",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { dense: "" } },
                                      [
                                        _c("v-col", { attrs: { sm: "10" } }, [
                                          _c("h4", { staticClass: "pt-6" }, [
                                            _vm._v("Ancillary Price Inputs"),
                                          ]),
                                        ]),
                                        _c(
                                          "v-col",
                                          { attrs: { sm: "2" } },
                                          [
                                            _c("v-switch", {
                                              attrs: {
                                                dense: "",
                                                label: "Active",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.change()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.computedValue.input
                                                    .energy_ancillary_inputs
                                                    .ancillary_settings.active,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.computedValue.input
                                                      .energy_ancillary_inputs
                                                      .ancillary_settings,
                                                    "active",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                        computedValue.input.energy_ancillary_inputs.ancillary_settings.active\n                      ",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    _c(
                                      "v-col",
                                      { attrs: { sm: "12" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            dense: "",
                                            label: "Price Source",
                                            items: _vm.priceSourceItems,
                                            "item-text": "text",
                                            disabled:
                                              !_vm.computedValue.input
                                                .energy_ancillary_inputs
                                                .ancillary_settings.active,
                                            rules: [
                                              function (v) {
                                                return !!v || "required"
                                              },
                                            ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.change()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.computedValue.input
                                                .energy_ancillary_inputs
                                                .ancillary_settings
                                                .ancillary_price_source,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.computedValue.input
                                                  .energy_ancillary_inputs
                                                  .ancillary_settings,
                                                "ancillary_price_source",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "\n                      computedValue.input.energy_ancillary_inputs.ancillary_settings\n                        .ancillary_price_source\n                    ",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.computedValue.input
                                      .energy_ancillary_inputs
                                      .ancillary_settings.active
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "pt-4",
                                                attrs: { dense: "" },
                                              },
                                              [
                                                _c("InputPriceMarket", {
                                                  attrs: {
                                                    "market-only":
                                                      _vm.ancillaryCustomPriceSource ===
                                                      "custom",
                                                    "energy-price-source":
                                                      "custom",
                                                    "ancillary-price-source":
                                                      "market",
                                                    dense: "",
                                                    "node-list": false,
                                                    "date-range": true,
                                                    "auto-select-first-market":
                                                      "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.$emit("change")
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.ancillaryMarkets,
                                                    callback: function ($$v) {
                                                      _vm.ancillaryMarkets = $$v
                                                    },
                                                    expression:
                                                      "ancillaryMarkets",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.ancillaryProductOptions &&
                                    _vm.computedValue.input
                                      .energy_ancillary_inputs
                                      .ancillary_settings.active
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                dense: "",
                                                label: "Ancillary Types",
                                                items:
                                                  _vm.ancillaryProductOptions,
                                                "item-text": "text",
                                                "item-value": "value",
                                                multiple: "",
                                                chips: "",
                                                "deletable-chips": "",
                                                rules: [
                                                  function (v) {
                                                    return (
                                                      (v && v.length > 0) ||
                                                      "select at least one"
                                                    )
                                                  },
                                                ],
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.change()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.ancillaryProductSelection,
                                                callback: function ($$v) {
                                                  _vm.ancillaryProductSelection =
                                                    $$v
                                                },
                                                expression:
                                                  "ancillaryProductSelection",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.ancillaryCustomPriceSource ==
                                      "custom" &&
                                    _vm.computedValue.input
                                      .energy_ancillary_inputs
                                      .ancillary_settings.active
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          _vm._l(
                                            _vm.ancillaryProductSelection,
                                            function (label) {
                                              return _c(
                                                "v-row",
                                                {
                                                  key: label,
                                                  attrs: { dense: "" },
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { sm: "12" } },
                                                    [
                                                      _c("InputYearlyProfile", {
                                                        attrs: {
                                                          value:
                                                            _vm.ancillaryCustomProfile(
                                                              label
                                                            ),
                                                          label:
                                                            "Custom Profile - " +
                                                            _vm.ancillaryProductLabelText(
                                                              label
                                                            ),
                                                          num_years:
                                                            _vm.numYears,
                                                          "spread-values": "",
                                                          fill: "",
                                                          "object-value": "",
                                                          "items-type":
                                                            "profile",
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            return _vm.setAncillaryCustomProfile(
                                                              label,
                                                              $event
                                                            )
                                                          },
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-card",
              { attrs: { flat: "" } },
              [
                _c("v-card-subtitle", [
                  _c("h3", [_vm._v("Fuel Price Inputs")]),
                ]),
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-card",
                      { attrs: { outlined: "" } },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-row",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { sm: "12" } },
                                  [
                                    _c("h4", { staticClass: "pb-4" }, [
                                      _vm._v("Historical"),
                                    ]),
                                    _c("v-divider"),
                                    _c(
                                      "v-col",
                                      { attrs: { sm: "12" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            dense: "",
                                            label: "Fuel Price Source",
                                            items: _vm.fuelSourceItems,
                                            rules: [
                                              function (v) {
                                                return !!v || "required"
                                              },
                                            ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.change()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.computedValue.input
                                                .fuel_price_inputs
                                                .historical_fuel_price
                                                .fuel_price_source,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.computedValue.input
                                                  .fuel_price_inputs
                                                  .historical_fuel_price,
                                                "fuel_price_source",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "\n                      computedValue.input.fuel_price_inputs.historical_fuel_price\n                        .fuel_price_source\n                    ",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.computedValue.input.fuel_price_inputs
                                      .historical_fuel_price
                                      .fuel_price_source === "market"
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c("InputMarketNode", {
                                              attrs: {
                                                market: "EIA",
                                                label: "Historical Source ID",
                                                params: {
                                                  query: {
                                                    Granularity: "Monthly",
                                                  },
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.fuelPriceHistoricalSourceElement,
                                                callback: function ($$v) {
                                                  _vm.fuelPriceHistoricalSourceElement =
                                                    $$v
                                                },
                                                expression:
                                                  "fuelPriceHistoricalSourceElement",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.computedValue.input.fuel_price_inputs
                                      .historical_fuel_price
                                      .fuel_price_source === "custom"
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c("InputYearlyProfile", {
                                              attrs: {
                                                label: "Custom Profile",
                                                num_years: _vm.numYears,
                                                "spread-values": "",
                                                fill: "",
                                                "object-value": "",
                                                "items-type": "profile",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.computedValue.input
                                                    .fuel_price_inputs
                                                    .historical_fuel_price
                                                    .profile,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.computedValue.input
                                                      .fuel_price_inputs
                                                      .historical_fuel_price,
                                                    "profile",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "computedValue.input.fuel_price_inputs.historical_fuel_price.profile",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-col",
                                      { attrs: { sm: "12" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            dense: "",
                                            label: "Fuel Type",
                                            items: _vm.fuelTypeItems,
                                            rules: [
                                              function (v) {
                                                return !!v || "required"
                                              },
                                            ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.change()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.computedValue.input
                                                .fuel_price_inputs
                                                .historical_fuel_price
                                                .fuel_type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.computedValue.input
                                                  .fuel_price_inputs
                                                  .historical_fuel_price,
                                                "fuel_type",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "\n                      computedValue.input.fuel_price_inputs.historical_fuel_price.fuel_type\n                    ",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { sm: "12" } },
                                  [
                                    _c("h4", { staticClass: "pb-4" }, [
                                      _vm._v("Forecast"),
                                    ]),
                                    _c("v-divider"),
                                    _c(
                                      "v-col",
                                      { attrs: { sm: "12" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            dense: "",
                                            label: "Fuel Price Source",
                                            items: _vm.fuelSourceItems,
                                            rules: [
                                              function (v) {
                                                return !!v || "required"
                                              },
                                            ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.change()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.computedValue.input
                                                .fuel_price_inputs
                                                .fuel_price_forecast
                                                .fuel_price_source,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.computedValue.input
                                                  .fuel_price_inputs
                                                  .fuel_price_forecast,
                                                "fuel_price_source",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "\n                      computedValue.input.fuel_price_inputs.fuel_price_forecast.fuel_price_source\n                    ",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.computedValue.input.fuel_price_inputs
                                      .fuel_price_forecast.fuel_price_source ===
                                    "market"
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c("InputMarketNode", {
                                              attrs: {
                                                market: "EIA-SOURCES",
                                                label: "Forecast Source ID",
                                              },
                                              model: {
                                                value:
                                                  _vm.fuelPriceForecastSourceElement,
                                                callback: function ($$v) {
                                                  _vm.fuelPriceForecastSourceElement =
                                                    $$v
                                                },
                                                expression:
                                                  "fuelPriceForecastSourceElement",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.computedValue.input.fuel_price_inputs
                                      .fuel_price_forecast.fuel_price_source ===
                                    "custom"
                                      ? _c(
                                          "v-col",
                                          { attrs: { sm: "12" } },
                                          [
                                            _c("InputYearlyProfile", {
                                              attrs: {
                                                label: "Values",
                                                num_years: _vm.forecastNumYears,
                                                "spread-values": "",
                                                fill: "",
                                                "object-value": "",
                                                "items-type": "constant",
                                                suffix: "$/MMBtu",
                                                "year-start":
                                                  _vm.forecastYearStart,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.computedValue.input
                                                    .fuel_price_inputs
                                                    .fuel_price_forecast.values,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.computedValue.input
                                                      .fuel_price_inputs
                                                      .fuel_price_forecast,
                                                    "values",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "computedValue.input.fuel_price_inputs.fuel_price_forecast.values",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-col",
                                      { attrs: { sm: "12" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            dense: "",
                                            label: "Fuel Type",
                                            items: _vm.fuelTypeItems,
                                            rules: [
                                              function (v) {
                                                return !!v || "required"
                                              },
                                            ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.change()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.computedValue.input
                                                .fuel_price_inputs
                                                .fuel_price_forecast.fuel_type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.computedValue.input
                                                  .fuel_price_inputs
                                                  .fuel_price_forecast,
                                                "fuel_type",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "computedValue.input.fuel_price_inputs.fuel_price_forecast.fuel_type",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { staticClass: "pt-4", attrs: { sm: "12" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            label: "Fuel Delivery Charge",
                            type: "number",
                            rules: [
                              function (v) {
                                return !!(v !== "") || "required"
                              },
                            ],
                          },
                          on: {
                            change: function ($event) {
                              return _vm.change()
                            },
                          },
                          model: {
                            value:
                              _vm.computedValue.input.fuel_price_inputs
                                .fuel_delivery_charge,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.computedValue.input.fuel_price_inputs,
                                "fuel_delivery_charge",
                                _vm._n($$v)
                              )
                            },
                            expression:
                              "computedValue.input.fuel_price_inputs.fuel_delivery_charge",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-row",
              [
                _c("v-col", { attrs: { sm: "4" } }),
                _c("v-col", { attrs: { sm: "4" } }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }